/***********************************************
* CutTool.js
* 
* Cuts a part of the pointcloud
***********************************************/
/* Layout files */
import '../../assets/style/Tools.css';

/* Global imports */
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';

/* Local imports */
import API from '../API';
//import DatePicker from './DatePicker';
import UploadZone from './UploadZone';

import { ProgressPopup } from '../Popup';

function CutTool(props) {
    const [zone, setZone] = useState(0);
    const [id,   setId]   = useState(props.id);
    const [cutId, setCutId] = useState(0);
    const [isDone, setIsDone] = useState(false);

    const [availableDates, setAvailableDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");

    const [open, setOpen] = useState(false);
    const [progress, setProgress] = useState(0.0);

    useEffect(() => {
        setId(props.id);
        setSelectedDate("");
        API.GetOutputDates(props.id, (reply) => {setAvailableDates(reply);});
    }, [props.id]);

    useEffect(() => {
        if(cutId !== 0) {
            const interval = setInterval(() => {
                API.IsCutDone(cutId, (reply) => {
                    if(reply['isCut'] === true) {
                        clearInterval(interval);
                    }
                    setIsDone(reply['isCut']);
                });
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [cutId]);

    const dateSelect = () => {
        var options = [<option key="emptyOption" value="" disabled>Select date</option>]
        availableDates.forEach((date) => { options.push(<option key={date} value={date}>{date}</option>) });
        return <select name="dateSelect" onChange={(e) => {setSelectedDate(e.target.value);}} value={selectedDate}>{options}</select>;
    }

    return (
        <div className='flexTool'>
            <div className='toolTitle'>{props.t("cut")}</div>
            <div><label>Select DXF zone</label><UploadZone t={props.t} id={id} onZoneId={(id) => {setZone(id);}}/></div>
            <div><label>Select scan</label>
                {/*<DatePicker className="datePicker" availableDates={availableDates} onDatePicked={(date, match) => {setSelectedDate(match);}}/>*/}
                {dateSelect()}
            </div>
            <div>
                <button 
                    disabled={(zone === 0) || (selectedDate === "")}
                    className='bigButton' 
                    onClick={() => {API.DoCut(id, zone, selectedDate, (reply) => {setCutId(reply['id']);})}}
                >
                        {props.t("cut")}
                </button>
                <button 
                    disabled={!isDone}
                    className='bigButton' 
                    onClick={() => {API.DownloadCutFile(cutId, (progress)=>{
                        setOpen(progress > 0.0 && progress < 1.0);
                        setProgress(progress);
                    }, null);}
                    }
                >
                        {props.t("download")}
                </button>
            </div>
            <ProgressPopup key="popup" open={open} progress={Math.round(progress * 100)} title="Download Cut" />
        </div>
    );
}

export default withTranslation("Projects")(CutTool);